import React from 'react';
import { compose, branch, renderNothing } from 'recompose';
import { useTranslations } from 'js/hooks/i18n';
import { Link } from 'js/components/common/Link';
import style from './index.scss';

export const TermsAndConditions = ({ termsAndConditionsUrl, className = '' }) => {
    const t = useTranslations();
    return (
        <div className={style.container}>
            <Link
                href={termsAndConditionsUrl}
                inNewWindow={true}
                className={`${style.link} ${className}`}>
                {t('playtech.mobile.system.casino-leaderboard.termsAndConditions')}
            </Link>
        </div>
    );
};

export default compose(
    branch(
        ({ termsAndConditionsUrl }) => !termsAndConditionsUrl,
        renderNothing
    )
)(TermsAndConditions);
